export class PublicCartDiscount {
  public constructor(
    private readonly data: {
      description: string;
      discount: number;
    },
  ) {}

  public get description(): string {
    return this.data.description;
  }

  public get discount(): number {
    return this.data.discount;
  }
}
